/**
 * Cleanup the browser history state, which was pushed by the attachBrowserBackButtonListener function.
 * @param stateName The name of the state to be pushed to the browser history.
 * @param options.skipNavigation When true, only clears the state flag without calling history.back().
 *   Use this when another navigation (e.g. form submit) will happen immediately after cleanup,
 *   to avoid conflicting simultaneous navigations.
 * @returns void
 */
export function cleanupHistoryState(
  stateName: string,
  options?: { skipNavigation?: boolean }
): void {
  const hasPushedState = window.history.state?.[stateName]
  if (!hasPushedState) {
    return
  }

  window.history.replaceState(
    {
      ...window.history.state,
      [stateName]: false,
    },
    ''
  )

  if (!options?.skipNavigation) {
    window.history.back()
  }
}
